import {Link} from "react-router-dom";

export default function CategoryItem({item}) {

    return (
        <div className={'col-md-3 col-sm-4 col-6 my-1'}>
            <Link to={`/categories/${item.id}`} className={'anchor'}>
                <div className="flex-column justify-content-center align-items-center">
                    <div className="category-item" style={{backgroundImage:`url("${item.img}")`}}></div>
                    <div className="category-title text-center">{item.name}</div>
                </div>
           {/* <div className=" category-item " >
                <div className="background" style={{backgroundImage: `url(${item.img})`}}></div>
                <img className={'m-auto d-block'} src={item.img} loading={'lazy'} alt=""/>

            </div>
                <div className={'category-item-overlay text-white text-center py-2'}></div>*/}
            </Link>
        </div>

    )
}